import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  Add as AddIcon,
  Menu as Menu,
  Settings as Settings,
  FormatListBulleted as FormatListBulleted,
  Mail as Mail,
  DateRange as DateRange,
  Business as Business,
  Person as Person,
  ShowChart as ShowChart,
  ArrowBack as ArrowBackIcon,
  Equalizer as Equalizer,
  CompareArrows as IntermediariesIcon,
  MenuBook as MasterIcon,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter, useParams } from "react-router-dom";
import classNames from "classnames";
import _ from '../../utils/languages/languages';
import Cookies from 'universal-cookie';

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";


function getIconFromType(type){
  return <HomeIcon />;
}



function Sidebar({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();

  //var props = useParams();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  //let menuItems = JSON.parse(props);

  let jsonItems = [];
  try {
    jsonItems = props.menuItems;
  }
  catch (error){}

  const cookies = new Cookies();
  const username = cookies.get('username', { path: '/' });
  const token = cookies.get('token', { path: '/' });
  const userType = cookies.get('userType', { path: '/' });
  const brokerType = cookies.get('brokerType', { path: '/' });
  
  let structure = (userType == 2 ? brokerType == 'company' ? [
    { id: 8, label: "Companies list", link: "/app/companiesBroker", icon: <Business /> },
   // { id: 11, label: "Stats", link: "/app/statsBroker", icon: <Equalizer /> },
    { id: 5, type: "divider" },
    { id: 3, label: "Account settings", link: "/app/usersettings", icon: <Settings /> },
  ] : [
    { id: 9, label: "Investors list", link: "/app/investorsBroker", icon: <Person /> },
    { id: 10, label: "Analysts list", link: "/app/analystsBroker", icon: <ShowChart /> },
   // { id: 11, label: "Stats", link: "/app/statsBroker", icon: <Equalizer /> },
    { id: 5, type: "divider" },
    { id: 3, label: "Account settings", link: "/app/usersettings", icon: <Settings /> },
  ]
     :
    username == 'admin' ? [
    { id: 1, label: "Accounts List", link: "/app/accountslist", icon: <FormatListBulleted /> },
    { id: 2, label: "Add account", link: "/app/addaccount", icon: <AddIcon /> },
    { id: 3, label: "Admin settings", link: "/app/adminsettings", icon: <Settings /> },
  ] : [
    { id: 1, label: "Events List", link: "/app/eventslist", icon: <FormatListBulleted /> },
    { id: 2, label: "New Event", link: "/app/newevent", icon: <AddIcon /> },
    { id: 3, label: "Account settings", link: "/app/usersettings", icon: <Settings /> },
    { id: 5, type: "divider" },
    { id: 6, label: "Event details", link: "/app/eventdetails", icon: <DateRange /> },

    { id: 7, label: "Intermediaries", link: "/app/intermediaries", icon: <IntermediariesIcon /> },
    { id: 8, label: "Companies list", link: "/app/companies", icon: <Business /> },
    { id: 9, label: "Investors list", link: "/app/investors", icon: <Person /> },
    { id: 10, label: "Analysts list", link: "/app/analysts", icon: <ShowChart /> },
    { id: 11, label: "Master", link: "/app/master", icon: <MasterIcon /> },
    { id: 12, label: "Stats", link: "/app/stats", icon: <Equalizer /> },
  ]);

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
      style={{position: 'sticky'}}

    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
      <div style={{ position: 'absolute', bottom: 0, left: 35 }}>
        <p style={{ color: 'darkgrey' }}>v. 1.11.1 (14022024)</p>
      </div>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
